import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { DashboardFilterBar } from '@/features/dashboard-filters';
import { useHeaderFilters } from '@/features/header-filters';

import { useServiceUsers } from '../model';
import { ServiceUsersPage } from './service-users-page';

/**
 * Hands the service-user filters to the shared header panel, leaving the page to
 * its stats and charts. Filters apply as they change, so the panel's Apply only
 * closes it.
 */
export function ServiceUsersWithFilters() {
  const { t } = useTranslation();
  const { setFilterConfig } = useHeaderFilters();
  const serviceUsers = useServiceUsers();

  const {
    urlState,
    locationsData,
    selectedLocations,
    setSelectedLocations,
    locationsLoading,
    organizationGroups,
    selectedOrganizations,
    setSelectedOrganizations,
    organizationsLoading,
    updateOption,
    handleDateRangeChange,
    activeFilters,
    activeFiltersCount,
    hasActiveFilters,
    resetFilters
  } = serviceUsers;

  useEffect(() => {
    setFilterConfig({
      id: 'service-users-filters',
      title: t('welcome.serviceusers.label'),
      content: (
        <DashboardFilterBar
          variant="service-users"
          options={urlState}
          onOptionChange={updateOption}
          locationGroups={locationsData?.locationGroups}
          selectedLocations={selectedLocations}
          onLocationsChange={setSelectedLocations}
          locationsLoading={locationsLoading}
          organizationGroups={organizationGroups}
          selectedOrganizations={selectedOrganizations}
          onOrganizationsChange={setSelectedOrganizations}
          organizationsLoading={organizationsLoading}
          onDateRangeChange={handleDateRangeChange}
        />
      ),
      activeCount: activeFiltersCount,
      activeFilters,
      onReset: resetFilters,
      onClearAll: resetFilters,
      isResetDisabled: !hasActiveFilters
    });
  }, [
    urlState,
    locationsData,
    selectedLocations,
    setSelectedLocations,
    locationsLoading,
    organizationGroups,
    selectedOrganizations,
    setSelectedOrganizations,
    organizationsLoading,
    updateOption,
    handleDateRangeChange,
    activeFilters,
    activeFiltersCount,
    hasActiveFilters,
    resetFilters,
    setFilterConfig,
    t
  ]);

  return <ServiceUsersPage serviceUsers={serviceUsers} />;
}
